module.exports = __webpack_public_path__ + "static/media/pen-ryn-large.29b13250.jpg";